export class AdvanceSearchDto {
    storeNumber: string;
    purchaseOrderNumber: string;
    poSignedBy: string;
    poFromCreatedDate: string;
    poToCreatedDate: string;
    poFromReceivedDate: string;
    poToReceivedDate: string;
    poStatus: string;
    poStatusArray:[];
    poType: string;
    pageNo: number;
    pageSize: number;
    order: string;
    sort: string
}
